"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aggregate = void 0;
const Entity_1 = require("./Entity");
class Aggregate extends Entity_1.Entity {
    constructor() {
        super(...arguments);
        this.changesOnAggregateRoot = [];
    }
    addChange(change) {
        this.changesOnAggregateRoot.push(change);
    }
    flushChanges() {
        this.changesOnAggregateRoot = [];
    }
    getChanges() {
        return this.changesOnAggregateRoot;
    }
}
exports.Aggregate = Aggregate;
